import { BaseModel } from '../../_base/crud';
import { OfficeModel } from '../../management';

export class Doctor extends BaseModel {
  id: number;
  phone: string;
  cell_phone: string;
  fax: string;
  email: string;
  is_active: boolean;
  city: string;
  state: string;
  note: string;
  processed: boolean;
  zip: string;
  office_phone: string;
  companyID: number;
  first_name: string;
  last_name: string;
  dea: any;
  npi: any;
  sln: any;
  office: OfficeModel;
  office_id: number;
  office_name: string;
  form: any;
  form_data: any;
  img = './assets/media/users/300_21.jpg';
  address_2: any;
  address_1: any;
  doctor_id: string;
  location_id: any;
  last_user_mod: any;
  last_modified_user: any;
  tags: any;
  affiliation_groups: any;
  urbanization: any;
  last_name2;
  middle_name;
  latitude: any;
  longitude: any;
  plus_code: any;
  provider_types: any;
  practice_name: any;
  gender;
  geolocation_address;
  avatar;
  pre_signed_url;
  extension: any;
  clear(): void {
    this.id = 0;
    this.practice_name = '';
    this.first_name = '';
    this.last_name = '';
    this.middle_name = '';
    this.last_name2 = '';
    this.cell_phone = '';
    this.fax = '';
    this.city = '';
    this.state = '';
    this.email = '';
    this.note = '';
    this.processed = false;
    this.office_name = '';
    this.office_phone = '';
    this.phone = '';
    this.tags = [];
    this.is_active = true;
    this.office_id = null;
    this.office = null;
    this.gender = null;
    this.extension = null;
  }
}
